module.exports = __webpack_public_path__ + "img/thumb-005-10.7c61cf94.png";